module.exports = __webpack_public_path__ + "img/DE00466.911f0a79.png";